import { Component } from "@angular/core";

@Component({
  selector: "ta-page-divider",
  template: `
    <ta-box margin="4rem -6rem" class="border--bottom"></ta-box>
  `
})
export class PageDividerComponent {}
